<template>
  <div class="wrapper no-print" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar :background-color="sidebarBackground">
      <template slot="links">
        <!-- <sidebar-item :link="{name: 'Visão Geral', icon: 'ni ni-chart-bar-32 text-black', path: '/painel' }"/> -->
        <sidebar-item v-if="usuario && usuario.tipo !== 'pro'" :link="{name: 'Dashboard', icon: 'fas fa-tachometer-alt text-white', path: '/dashboard'}"/>
        <sidebar-item v-if="usuario && usuario.tipo === 'den'" :link="{name: 'Ordens de Serviços', icon: 'ni ni-bullet-list-67 text-white', path: '/ordens'}"/>
        <sidebar-item v-if="usuario && usuario.tipo === 'lab'" :link="{name: 'Solicitações', icon: 'ni ni-bullet-list-67 text-white', path: '/solicitacoes', counter}"/>
        <sidebar-item v-if="usuario && usuario.tipo === 'lab'" :link="{name: 'Dentistas Externos', icon: 'fas fa-user-ninja text-white', path: '/dentistas-externos'}"/>
        <sidebar-item v-if="usuario && usuario.tipo !== 'den'" :link="{name: 'Agenda Prótetica', icon: 'fas fa-calendar-alt text-white', path: '/agenda-protetica'}"/>
        <sidebar-item v-if="usuario && usuario.tipo === 'pro'" :link="{name: 'Solicitações', icon: 'ni ni-bullet-list-67 text-white', path: '/solicitacoes'}"/>
        <div style="border-bottom: 1px solid white; opacity: 0.3; margin: 10px 20px;"></div>
        <sidebar-item v-if="usuario && usuario.tipo !== 'den'" :link="{name: 'R. de Procedimentos', icon: 'fas fa-file-alt text-white', path: '/relatorio-procedimentos'}"/>
        <sidebar-item v-if="usuario && usuario.tipo !== 'pro'" :link="{name: 'R. de Solicitações', icon: 'fas fa-file-alt text-white', path: '/relatorio-solicitacoes'}"/>
        <div style="border-bottom: 1px solid white; opacity: 0.3; margin: 10px 20px;" v-if="usuario && usuario.tipo === 'lab'"></div>
        <sidebar-item v-if="usuario && usuario.tipo === 'lab'" :link="{name: 'Financeiro', icon: 'fas fa-money-bill-wave', path: '/financeiro'}"/>
        <sidebar-item v-if="usuario && usuario.tipo === 'lab'" :link="{name: 'Estoque', icon: 'fas fa-cubes text-white', path: '/estoque'}"/>
        <div style="border-bottom: 1px solid white; opacity: 0.3; margin: 10px 20px;" v-if="usuario && usuario.tipo !== 'den'"></div>
        <sidebar-item v-if="usuario && usuario.tipo !== 'den'" :link="{name: 'Procedimentos', icon: 'fas fa-drafting-compass text-white', path: '/procedimentos-proteticos'}"/>
        <sidebar-item v-if="usuario && usuario.tipo === 'lab'" :link="{name: 'Usuários Protéticos', icon: 'fas fa-users-cog text-white', path: '/usuarios-proteticos'}"/>
        <sidebar-item v-if="usuario && usuario.tipo === 'lab'" :link="{name: 'Parâmetros', icon: 'fas fa-cogs text-white', path: '/parametros'}"/>
        <sidebar-item v-if="usuario && usuario.tipo === 'lab'" :link="{name: 'Ficha Modelo', icon: 'fas fa-file-invoice text-white', path: '/ficha-modelo'}"/>
        <div style="border-bottom: 1px solid white; opacity: 0.3; margin: 10px 20px;" v-if="usuario && usuario.tipo === 'den' && usuario.isAdmin == '1'"></div>
        <sidebar-item v-if="usuario && usuario.tipo === 'den' && usuario.isAdmin == '1'" :link="{name: 'Faturas', icon: 'fas fa-money-bill-wave text-white', path: '/faturas'}"/>
        <sidebar-item v-if="usuario && usuario.tipo === 'den' && usuario.isAdmin == '1'" :link="{name: 'Assinaturas', icon: 'fas fa-pen-fancy text-white', path: '/assinaturas'}"/>
        <sidebar-item v-if="usuario && usuario.tipo === 'den' && usuario.isAdmin == '1'" :link="{name: 'Usuários', icon: 'fas fa-users text-white', path: '/usuarios'}"/>
        <div style="border-bottom: 1px solid white; opacity: 0.3; margin: 10px 20px;"></div>
        <sidebar-item :link="{name: 'Minha Assinatura', icon: 'fas fa-user-circle text-white', path: '/minha-assinatura'}"/>
        <!-- <sidebar-item :link="{name: 'Minha conta', icon: 'fas fa-user-edit text-white', path: '/conta'}"/> -->
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <div class="fixed-top full-width devWarning" v-if="!isProd">Ambiente de desenvolvimento</div>
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import storage from 'storage';
  import infodash from "@/cflow/infodash.js";

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue', //vue|blue|orange|green|red|primary
        usuario: null,
        isProd: process.env.NODE_ENV === 'production',
        counter: -1
      };
    },
    mounted(){
      const _this = this;
      _this.usuario = storage.get('user');
      _this.initInfoDash();
      
    },
    watch: {
      'counter': function() {
        const _this = this;
        setInterval(function(){
          _this.initInfoDash();
        }, 5000)
      }
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      initInfoDash() {
        const _this = this;
        infodash
          .labView()
          .then((res) => {
            let doReload = false;
            if(_this.counter !== res.length) {
              doReload = true;
            }
            _this.counter = res.length;

            if(doReload ==true && _this.$route.path == '/solicitacoes') {
              _this.$router.push({ query: { ..._this.$route.query, t: Date.now() }})
            }
          })
      }
    }
  };
</script>
<style lang="scss">
.devWarning{
  text-align: center;
  padding: 5px 0;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  background-color: rgba(255, 0, 0, 0.493);
  pointer-events: none;
}
</style>
